<template lang="pug">
  div.container
    header-without-menu
    div.row.justify-content-center
      div.col-sm-10
        b-card.auth-card.shadow.mx-auto
          img.logo-img.mb-5(src="@/assets/LMM-3.0-logo.svg", alt="LinkMeMine Logo")
          
          div.d-flex.justify-content-center.align-items-center.mb-4
            icon.auth-status.mr-2(:class="code", :name="state", :spin="state === 'spinner'", scale="1.8")
            h3.mb-0 {{titleMessage}}
          p.text-muted.mb-5(v-html="$t(`email-auth-${code}`)")
          
          // 로그인 버튼
          b-button(variant="info", size="lg", :disabled="code === 'wait'", @click="goHome") {{$t('navigate_to_home')}}
          
          // 푸터
          div.mt-4.text-muted.small {{$t('footer')}}
</template>

<script>
import {checkAuth} from '@/api/access'
import {HeaderWithoutMenu} from '../../mixins/header'

export default {
  name: 'welcome-component',
  components: {HeaderWithoutMenu},
  mounted() {
    this.loaded = true
    
    const {type, key} = this.$route.query
    if (!type || !key) {
      this.$router.push({name: 'error', params: {code: 400}})
      return
    }
    
    checkAuth(key).then(resp => {
      const code = resp.result.toLowerCase()
      this.code = code
      if (code === 'fail') {
        this.state = 'exclamation-triangle'
      } else if (code === 'already') {
        this.state = 'check-circle'
      } else if (code === 'success') {
        this.state = 'check-circle'
      }
    })
  },
  computed: {
    titleMessage() {
      switch (this.code) {
        case 'success':
          return this.$t('email_verification_success')
        case 'already':
          return this.$t('email_already_verified')
        case 'fail':
          return this.$t('email_verification_failed')
        default:
          return this.$t('email_verification_pending')
      }
    },
  },
  data() {
    return {
      loaded: false,
      state: 'spinner',
      code: 'wait',
    }
  },
  methods: {
    goHome() {
      if (this.code !== 'wait') {
        this.$router.push('/')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.auth-card {
  margin-top: 15vh;
  border-radius: 1rem;
  text-align: center;
  padding: 2rem 0;
  max-width: 600px;
  width: 100%;
}

@media (max-width: 576px) {
  .auth-card {
    padding: 1rem 0;
  }
}

.logo-img {
  width: 50vw;
  max-width: 300px;
  height: auto;
}

@media (max-width: 576px) {
  h3 {
    font-size: 1.25rem;
  }
  p {
    font-size: 0.9rem;
  }
  .btn {
    font-size: 1rem;
    padding: 0.75rem 1rem;
  }
}

.auth-status {
  &.spinner {
    color: grey;
  }
  
  &.success {
    color: #3fc13f;
  }
  
  &.already {
    color: grey;
  }
  
  &.fail {
    color: #d64b4b;
  }
}

.btn {
  width: 250px;
  
  &:disabled {
    background-color: #c4c4c4 !important;
    border: 1px solid #d2d2d2;
    cursor: not-allowed;
    color: #666;
  }
}
</style>
